"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSiteObject = exports.createPageObject = void 0;

var createPageObject = function createPageObject(pageName, pageType, primaryCategory, subCategory1, subCategory2) {
  var pageObject = {
    pageInfo: {
      pageName: pageName,
      pageType: pageType
    },
    category: {
      primaryCategory: primaryCategory,
      subCategory1: subCategory1,
      subCategory2: subCategory2
    }
  };
  return pageObject;
};

exports.createPageObject = createPageObject;

var createSiteObject = function createSiteObject(betaSite, experienceType, siteId) {
  var siteObject = {
    betaSite: betaSite,
    experienceType: experienceType,
    siteId: siteId
  };
  return siteObject;
};

exports.createSiteObject = createSiteObject;
//# sourceMappingURL=page.js.map